<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[
        { name: 'Shareholder Meeting', to: { path: '/shareholder-meeting' } },
      ]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Shareholder Meeting</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增Meeting</span>
      </button>
    </div>
    <!--  -->
    <ShareholderMeetingTable class="mb-5"></ShareholderMeetingTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import ShareholderMeetingTable from '@/views/I-3__IR-ShareholderMeeting/c/ShareholderMeetingTable.vue';

export default {
  components: {
    BreadScrumbs,
    ShareholderMeetingTable,
  },
  created() {
    this.clear();
    this.getShareholderMeetings();
  },
  methods: {
    ...mapActions('shareholderMeeting', {
      getShareholderMeetings: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push('/shareholder-meeting/create');
    },
    toEditPageTitle() {
      this.$router.push(
        '/shareholder-meeting/edit-shareholder-meeting-page-title',
      );
    },
  },
};
</script>

<style></style>
